"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  voyagePlanSearch: {
    title: 'Shipping Schedule',
    polZH: 'POL',
    podZH: 'POD',
    startDate: 'Start Date',
    withinOneWeek: '+ 1 Week',
    withinTwoWeek: '+ 2 Weeks',
    withinThreeWeek: '+ 3 Weeks',
    withinFourWeek: '+ 4 Weeks',
    tips_1: 'Warm Tips：',
    tips_2: '（1） The schedule is for your reference only.Any question,please contact our local agent.',
    tips_4: '（2） ETD：Estimated Time of Departure ; ETA：Estimated Time of Arrival.',
    tips_5: '（3） CTD：Actual Time of Departure ；CTA：Actual Time of Arrival.',
    lane: 'Lane',
    vessel: 'VESSEL/VOYAGE',
    terminal: 'Terminal',
    polEN: 'POL',
    podEN: 'POD',
    etd: 'ETD',
    eta: 'ETA',
    sailingTime: 'Transit',
    day: 'days',
    transfer: 'Transfer',
    hour: 'hours',
    transshipment: 'TRANSSHIPMENTS',
    resultTips_1: 'No direct shipping schedule found,',
    resultTips_2: 'Click to skip to transfer query',
    resultTips_3: 'No request data currently available',
    etd1: '（Estimated Time Of Departure）',
    etb1: '（Estimated Time of Arrival）',
    showDetail: 'Display Detail',
    hideDetail: 'Hide Detail',
    subscribe: 'Subscribe',
    subscribeSuccess: 'Subscription successful',
    subscribeTips: 'Tips',
    sure: 'Sure',
    unsubscribe: '取消订阅(Unsubscribe)',
    unsubscribeSuccess: '取消订阅成功(Unsubscribed successfully)'
  }
};